define('controllers/financialaccount',['require'],function(require) {
	return function() {			
		$(function () {
			var showAccountRules = $("#showAccountRules");
			showAccountRules.on("click", function () {
				$("#accountRules").slideToggle('fast', function () {
					if ($(this).css("display") == "none") {
						showAccountRules.html("View Account Rules");
					}
					else {
						showAccountRules.html("Hide Account Rules");
					}
				});
			});

			$(".info").fancybox({
				maxWidth: 350,
				maxHeight: 700,
				fitToView: false,
				autoSize: true,
				closeClick: false,
				openEffect: 'none',
				closeEffect: 'none',
				padding: 0
			});

			$("#btnGetPlan").on("click", function (e) {
				if (window.Page_ClientValidate == undefined || Page_ClientValidate()) {
					var chkAgreeToTransfer = $("#chkAgreeToTransfer"),
						agree = chkAgreeToTransfer.length == 0 || chkAgreeToTransfer.is(":checked");

					if (agree) {
						$(this).hide().next().fadeIn('slow');
						gaTrack('conversions', 'linked account', ServerData.user.Email, 100);
					} else {
						e.preventDefault();
						Utilities.setError("You must agree before continuing.", $("#message_client"));
					}
				} else {
				    setTimeout(Page_ClientValidate, 100); //patch. for some reason the onclick attribute's do postback runs after this with '' for validation group instead of no validation groups
					e.preventDefault();
				}
			});
			
			window.validateCheckBoxChecked = function(sender, args) {
			    var chkCheckBox = $("#PDTermsAgree");
			    args.IsValid = chkCheckBox.length == 0 || chkCheckBox.is(':checked');
			}

			Utilities.setDefaultButton($("#financialPageContainer"), $("#btnGetPlan"));
			Utilities.setDefaultButton($("#accountVerification"), $("#btnVerifyAccount"));
		});
	};
});
